


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { FILTER_RULES_FIELDS, FILTER_RULES_OPERATORS, IRule, RuleOperators } from '@/helpers/filter-rules'
import { TrackFieldsLabels, TrackFields } from '@/constants'
import { COLORS } from '@/enums/generic'

@Component({
  components: {
    ColorPicker: require('@/components/ColorPicker').default
  }
})
export default class Rule extends Vue {
  @Prop()
  value: IRule

  @Prop()
  isFirst: boolean

  model: IRule = this.value
  rating1: number = 0
  rating2: number = 0

  availableFields: string[] = Object.keys(FILTER_RULES_FIELDS)
  filterRuleFields = FILTER_RULES_FIELDS
  filterRuleOperators = FILTER_RULES_OPERATORS
  fieldLabels = TrackFieldsLabels

  get fieldType(): string {
    return FILTER_RULES_FIELDS[this.model.field].type
  }

  get operator(): any {
    if (!this.model.operator) return null

    return FILTER_RULES_OPERATORS[this.fieldType][this.model.operator]
  }

  get showColorPicker(): boolean {
    return this.model.field === TrackFields.Color && !!this.model.operator && (this.model.operator === RuleOperators.Equals || (this.model.operator as any) === RuleOperators.DoesNotEqual)
  }

  get showRatingFields(): boolean {
    return this.model.field === TrackFields.Rating
  }

  getOperatorObj(op: string) {
    return FILTER_RULES_OPERATORS[this.fieldType][op]
  }

  remove() {
    this.$emit('remove')
  }

  onEnter() {
    this.$emit('enter')
  }

  focus() {
    const input1 = (this.$refs as any).input1

    if (input1) input1.focus()
  }

  created() {
    if (this.showRatingFields) {
      if (this.model.value1) {
        this.rating1 = (this.model.value1 as number) / (255 / 5)
      }

      if (this.model.value2) {
        this.rating2 = (this.model.value2 as number) / (255 / 5)
      }
    }
  }

  @Watch('rating1')
  watchRating1(r: number) {
    this.model.value1 = (255 / 5) * r
  }

  @Watch('rating2')
  watchRating2(r: number) {
    this.model.value2 = (255 / 5) * r
  }

  @Watch('model.field')
  watchField(field: string, oldField: string) {
    if (field !== oldField && this.model.operator) {
      if (!FILTER_RULES_OPERATORS[FILTER_RULES_FIELDS[field].type][this.model.operator]) {
        this.model.operator = null
        this.model.value1 = ''
        this.model.value2 = ''
      }

      if (field === TrackFields.Color) {
        this.model.value1 = COLORS.Red
      } else if (oldField === TrackFields.Color) {
        this.model.value1 = ''
      }
    }
  }

  @Watch('operator')
  watchOperator() {
    this.$nextTick(() => {
      this.focus()
    })
  }

  @Watch('model', { deep: true })
  watchModel(rule: IRule) {
    this.$emit('input', rule)
  }

  @Watch('value', { deep: true })
  watchValue(v: IRule) {
    this.model = v
  }
}
